/*
  Timing shared by the app's route guards (FeatureRoute / AccessRoute) and the
  feature-flag readiness they depend on. Kept together because the two values
  are coupled: the readiness deadline must sit above the guard wait so the
  normal PostHog identify race resolves before either fallback forces through.
*/

/*
  How long a route guard waits for permissions + feature flags to settle before
  it stops showing a spinner and makes an access decision.
*/
export const ROUTE_GUARD_WAIT_MS = 2000

/*
  Ultimate ceiling for useFeatureFlagsReady. If PostHog never (re)loads the
  identified user's flag set — e.g. the reloadFeatureFlags() request after
  identify() fails on a degraded network — report ready anyway so guards fall
  back to evaluating whatever flags are loaded instead of hanging on a permanent
  spinner. Must be greater than ROUTE_GUARD_WAIT_MS. See DORA-1151.
*/
export const FEATURE_FLAGS_READY_DEADLINE_MS = 5000
